import { render, staticRenderFns } from "./CampaignAdmin.vue?vue&type=template&id=ee36bb1e&scoped=true&"
import script from "./CampaignAdmin.vue?vue&type=script&lang=js&"
export * from "./CampaignAdmin.vue?vue&type=script&lang=js&"
import style0 from "./CampaignAdmin.vue?vue&type=style&index=0&id=ee36bb1e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee36bb1e",
  null
  
)

export default component.exports